export class MRNConfig{
    id:any=null;
    isAccountCodeActive:Boolean=false;
    isCenterCodeActive:Boolean=false;
    isDateFormatActive:Boolean=false;
    isSerialNumberActive:Boolean=false;
    dateFormat:any="ddMMyyyy";
    noOfDigits:any=5;
    centerCode:String=null;
    accountCode:String=null;
    accountId:Number;
}